<template>
  <div>
    <!-- <transition-group name="fade-transform" mode="out-in" class="d-flex"> -->
    <div class="d-flex" v-if="processedList.length > 0">
      <draggable
        v-model="processedList"
        :group="type"
        draggable=".draggable-tag"
        class="d-flex"
        @end="onDragEnd"
        :options="{ disabled: disableSort }"
      >
        <template v-for="(item, index) in processedList">
          <span
            :key="item.name"
            variant="lighten"
            style="font-size: 0.9rem;"
            class="tag pl-2 pr-2 d-flex"
            :class="{ 'draggable-tag': !disableSort }"
            :id="`segment-popover-${index}`"
            data-text="and"
          >
            <span class="align-middle" v-html="item.label"></span>
            <span
              v-if="item.deletable"
              class="align-middle pl-2 ml-2 border-left js-remove-segment"
              @click="deleteItem(index)"
            >
              <svg-icon icon="cross" class="icon-xs" />
            </span>
            <b-popover
              placement="bottom"
              :target="`segment-popover-${index}`"
              :ref="`popover-${index}`"
              @shown="popoverShown(index)"
              @hidden="popoverHidden(index)"
            >
              <div
                v-if="$scopedSlots.popover"
                v-click-outside="closePopover(index)"
                class="v-click-outside"
              >
                <slot
                  name="popover"
                  :item="item"
                  :index="index"
                  :popoverHidden="popoverHidden"
                  :isOpen="popoversState[index]"
                />
              </div>
            </b-popover>
          </span>
          <!-- <span
            class="position-relative d-inline-block text-light mr-2 ml-2 small"
            style="top: 1px;"
            :key="`${item.label}-joiner`"
            v-if="processedList.length !== index + 1"
          >
            and
          </span>
          &nbsp; -->
        </template>
      </draggable>
    </div>
    <!-- </transition-group> -->
  </div>
</template>

<script>
import cloneDeep from 'clone';
import draggable from 'vuedraggable';

const dictionary = {
  not: 'not',
  and: 'and',
  or: 'or',
  from: 'from',
  to: 'to',
  equal: 'equal'
};

export default {
  components: {
    draggable
  },

  props: {
    value: {
      type: Array,
      required: true
    },
    oneRequired: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      required: true
    },
    disableSort: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      popoversState: new Array(this.value.length).fill(false),
      processedList: null
    };
  },

  watch: {
    value: {
      immediate: true,
      handler(list) {
        this.processedList = this.processList(list);
      }
    }
  },

  methods: {
    onDragEnd() {
      this.$emit('input', this.processedList);
    },
    processList(list) {
      return list.map(el => {
        if (el.type === 'range') {
          return {
            ...el,
            label: this.rangeLabelRenderer(el),
            deletable: this.oneRequired ? list.length > 1 : true
          };
        }
        if (el.name) {
          return {
            ...el,
            label: el.name,
            deletable: this.oneRequired ? list.length > 1 : true
          };
        } else if (el.configurationName) {
          return {
            ...el,
            deletable: this.oneRequired ? list.length > 1 : true,
            label: this.labelRenderer(el)
          };
        }
      });
    },
    labelRenderer(item) {
      const joiner = ` <span class="text-light">${dictionary.or}</span> `;
      const segmentDesc = item.value
        .map(el => {
          return item.exclude
            ? `<span class="text-danger">${dictionary.not}</span> ${el.name}`
            : el.name;
        })
        .join(joiner);

      return `${item.configurationName}: ${segmentDesc}`;
    },

    rangeLabelRenderer(item) {
      const from = item.value.min;
      const to = item.value.max;
      let desc = `${item.configurationName}: `;
      if (from)
        desc += `<span class="text-light">${dictionary.from}</span> ${from} `;
      if (to) desc += ` <span class="text-light">${dictionary.to}</span> ${to}`;

      return desc;
    },

    deleteItem(i) {
      let list = cloneDeep(this.value);
      list.splice(i, 1);
      this.$emit('input', list);
    },

    closePopover(index) {
      return e => {
        const isInside = [...e.path].find(el => {
          const list = el.classList;
          return list ? list.contains('v-click-outside') : false;
        });
        if (
          this.$refs[`popover-${index}`] &&
          this.$refs[`popover-${index}`][0] &&
          this.popoversState[index] &&
          !isInside
        ) {
          this.$refs[`popover-${index}`][0].$emit('close');
          this.popoverHidden(index);
        }
      };
    },
    popoverShown(index) {
      this.$set(this.popoversState, index, true);
    },
    popoverHidden(index) {
      this.$set(this.popoversState, index, false);
    }
  }
};
</script>

<style lang="scss" scoped>
.tag {
  border: 1px solid lighten($lighten, 30%);
  display: inline-block;
  position: relative;
  margin-right: 40px;
  border-radius: $border-radius;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;

  &:after {
    content: attr(data-text);
    display: block;
    position: absolute;
    right: -40px;
    top: 0;
    width: 40px;
    text-align: center;
    color: $light;
    font-size: 80%;
  }

  &:last-child {
    margin-right: 0 !important;

    &:after {
      display: none;
    }
  }

  i {
    cursor: pointer;
    color: $lighten;

    &:hover {
      color: $primary;
    }
  }

  &.draggable-tag {
    cursor: grab;
  }
}
</style>
